module.exports = __webpack_public_path__ + "img/N3M3_new.7a9d9b88.jpg";